// src/theme/ColorModeContext.ts
import { createContext } from 'react';

export type ColorMode = 'light' | 'dark';

export const ColorModeContext = createContext<{
  mode: ColorMode;
  toggleColorMode: () => void;
}>({
  mode: 'light',
  toggleColorMode: () => {},
});
